// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowLeftIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ArrowLeftIcon" ref={forwardedRef} {...props}>
      <path d="M2.75 10.005 8.766 4l1.062 1.06-4.204 4.198H17.25v1.497H5.623l4.2 4.2-1.057 1.055z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowLeftIcon = /* @__PURE__ */ Object.assign(
  ArrowLeftIconComponent,
  { displayName: 'ArrowLeftIcon' },
);
